export default [
	{
		key: "created_at",
		title: "Last Running Time",
		scopedSlots: { customRender: "last_running_time" }
	},
	{
		key: "retry_count",
		title: "Count Retry",
		scopedSlots: { customRender: "retry_count" }
	},
	{
		key: "file_name",
		title: "File Name",
		scopedSlots: { customRender: "file_name" }
	},
	{
		key: "status",
		title: "Status",
		scopedSlots: { customRender: "status" }
	},
	{
		key: "action",
		title: "Action",
		scopedSlots: { customRender: "action" }
	}
];
